import React from 'react';
import './Footer.css';
import { highlightIndonesiaLestari } from '../../utils/textHelper'; // ✅ import helper

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <h2>
            FORPASI (Forum Peduli Sampah Seluruh Indonesia)
          </h2>
          <br />
          <p>Manajemen oleh: Yayasan Asa Indonesia Lestari</p>
          <br />
          <p>All rights reserved</p>
        </div>

        <div className="footer-social">
          <div className="social-icon-wrapper">
            <h2>Kunjungi Media Sosial Kami</h2>
            <div className="social-wrapper">
              <a href="https://www.linkedin.com/company/forpasi/" aria-label="LinkedIn" target="_blank"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://www.instagram.com/forpasi_id" aria-label="Instagram" target="_blank"><i className="fab fa-instagram"></i></a>
              <a href="https://www.youtube.com/@forpasi_id" aria-label="Youtube"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} FORPASI. Hak Cipta dilindungi undang undang.</p>
      </div>
      <div className="footer-hashtag">
        <h2>
          #Indonesia Lestari
        </h2>
      </div>
    </footer>
  );
};

export default Footer;
